export const TabKey = {
  YOU_GOV: 'you-gov',
  GOOGLE: 'google'
} as const;
export type TabKey = (typeof TabKey)[keyof typeof TabKey];

export const NAVS: { label: string; key: TabKey }[] = [
  { label: 'YouGov', key: TabKey.YOU_GOV },
  { label: 'Google', key: TabKey.GOOGLE }
];
